export default __webpack_public_path__ + "static/media/cursor_pen.d0b47239.png";